import { render, staticRenderFns } from "./ShowAsLabel.vue?vue&type=template&id=10998c9e&"
import script from "./ShowAsLabel.vue?vue&type=script&lang=js&"
export * from "./ShowAsLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports